import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { ReactElement, ReactNode } from 'react';

import { ReactComponent as CheckCircleOutlineIcon } from '~/ui/assets/images/check_circle_outline.svg';
import smallAvatarIcon from '~/ui/assets/images/smallAvatar.svg';
import PrivateImage from '~/ui/components/common/PrivateImage';
import DispatchedTypography from '~/ui/pages/Network/components/DispatchedTypography';

import styles from './AllocationClientRow.module.scss';

interface IAllocationClientRowData {
  clientId: number;
  photo?: string;
  name: string;
  isResolved: boolean;
  isCrisis: boolean;
}

interface IProps {
  client: IAllocationClientRowData;
  memoField: ReactNode;
  actions?: ReactNode;
  alertMessage?: string | null;
  noteMessage?: string | null;
  teamsField?: ReactNode;
}

const AllocationClientRow = ({
  client,
  memoField,
  actions,
  alertMessage,
  noteMessage,
  teamsField,
}: IProps): ReactElement => {
  const { photo, name, isResolved, isCrisis } = client;

  return (
    <Grid container alignItems="center" className={styles.clientDetailItem}>
      <Grid item xs={teamsField ? 4 : 6} className={styles.selectedClient}>
        <PrivateImage
          disabled={isResolved}
          className={styles.image}
          src={photo || smallAvatarIcon}
          height={40}
          alt="avatar"
          additionalIcon={
            isResolved ? (
              <div className={styles.additionalIcon}>
                <CheckCircleOutlineIcon width={16} height={16} />
              </div>
            ) : undefined
          }
        />
        <Typography>{name}</Typography>
        {isCrisis && <DispatchedTypography />}
      </Grid>
      {teamsField && (
        <Grid item xs={4} className={styles.teamField}>
          {teamsField}
        </Grid>
      )}
      <Grid item xs={teamsField ? 4 : 6} className={styles.memoContainer}>
        {memoField}
        {actions}
      </Grid>
      {alertMessage && (
        <Grid item sm={12} className={styles.validationErrors}>
          {alertMessage}
        </Grid>
      )}
      {noteMessage && (
        <Grid item sm={12} className={styles.validationErrors}>
          {noteMessage}
        </Grid>
      )}
    </Grid>
  );
};

export default AllocationClientRow;
